<template>
  <div>
    <page-loading v-if="!item && !noData" />
    <b-row v-if="noData">
      <b-col>
        <p>This station has not collected any allergen data.</p>
      </b-col>
    </b-row>
    <b-row v-if="item">
        <b-col sm="8">
            <div class="">
                <stationPage-title :title="stationPageTitle" :hideHome="true" />
            </div>
            <h2 v-if="item" class="">{{pageDate}}</h2>
            <div class="float-left">
                <b-link :to="calendarUrl">Change Date</b-link>&nbsp;|&nbsp;
            </div>
            <div v-if="!subscription" class="float-left">
                <b-link @click="onStationAdded(triggers[1].value)">Add to My NAB</b-link>&nbsp;|&nbsp;
            </div>
            <div v-if="subscription" class="float-left">
                <b-link @click="onStationRemoved">Remove from My NAB</b-link>&nbsp;|&nbsp;
            </div>
            <div class="float-left">
                <b-link to="/">View All Stations</b-link>
            </div>
        </b-col>
      <b-col sm="4" class="text-right">
        <!--<h2 v-if="item" class="mt-4">{{pageDate}}</h2>
        <div>
          <b-link :to="calendarUrl">Change Date</b-link>
        </div>-->
        <div v-if="subscription">
          <b-link @click="onChangeTrigger">{{getTriggerText(subscription.trigger)}}</b-link>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <hr />
      </b-col>
    </b-row>
    <b-row>
      <b-col :lg="mainColumns">
        <content-block name="StationDetailsTop" v-if="item" :tokens="item.station" />
      </b-col>
      <b-col v-if="sideColumns > 0" :lg="sideColumns">
        <b-card>
          <h2>My NAB</h2>
          <content-block name="StationSidebarPublicUser" />
          <b-button variant="primary" @click="openAuthForm('signup')">Sign Up</b-button>
          <b-button variant="secondary" @click="openAuthForm('login')">Log In</b-button>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="item && item.comment && item.isCommentPublic">
      <b-col>
        <hr />
        <p class="lead">
          Station Notes: {{item.comment}}
        </p>
      </b-col>
    </b-row>
    <b-row v-if="item && item.weatherNotes">
      <b-col>
        <hr />
        <p class="lead">
          Weather Notes: {{item.weatherNotes}}
        </p>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <allergen-collection-set-card v-if="item" :station="item.station" :allergenCollectionSet="item" :showBadges="true" :showDetails="true"></allergen-collection-set-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <content-block name="StationDetailsBottom" v-if="item" :tokens="item.station" />
      </b-col>
    </b-row>
    <b-modal id="changeTriggerModal" title="Change Email Alert Trigger" header-bg-variant="primary" header-text-variant="light" @ok="onChangeTriggerSubmit">
      <b-form novalidate @submit.prevent>
        <select-control v-if="changeTriggerValue" label="Email Alert Trigger" description="You can receive email alerts whenever new allergen counts are available for this station. Or you can choose to just have this station occur on your My NAB dashboard." v-model="changeTriggerValue" :options="triggers" required></select-control>
      </b-form>
    </b-modal>
    <auth-modal :authBus="authBus" @onAuthComplete="onAuthComplete"></auth-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import CrudOperationsMixin from '../Common/CrudOperationsMixin.js'
import DateTimeMixins from '../Common/DateTimeMixins.js'
import SubscriptionMixins from '../Common/SubscriptionMixins.js'

export default {
  name: "StationView",
  mixins: [
    CrudOperationsMixin,
    DateTimeMixins,
    SubscriptionMixins
  ],
  props: [
  ],
  data() {
    return {
      stationId: null,
      allergenCollectionSetId: null,
      item: null,
      user: null,
      subscription: null,
      authBus: new Vue(),
      changeTriggerValue: null,
      noData: false
    };
  },
  computed: {
    isAuthenticated: function () {
      return this.$root.$data.authenticatedUser.id && this.$root.$data.authenticatedUser.username.length > 0;
    },
    mainColumns: function () {
      if (!this.isAuthenticated)
        return 8;
      
      return 12;
    },
    sideColumns: function () {
      return 12 - this.mainColumns;
    },
    calendarUrl: function () {
      if (this.item) {
        let d = this.getSafeDate(new Date(this.item.date));
        return '/station/' + this.stationId + '/calendar/' + d.getFullYear() + '/' + (d.getMonth() + 1);
      }
      else
        return '/station/' + this.stationId + '/calendar';
    },
    detailsUrl: function () {
      return '/station/' + this.stationId + '/details';
    },
    pageTitle: function () {
      return this.item.station.displayCity + ', ' + this.item.station.state;
      },
      stationPageTitle: function () {
          return this.item.station.displayCity + ', ' + this.item.station.state;
      },
    pageDate: function () {
      return this.formatDateForUser(new Date(this.item.date));
    }
  },
  methods: {
    onChangeTriggerSubmit: function () {
      this.updateSubscription(this.subscription.id, this.changeTriggerValue)
        .then((subscription) => {
          this.loadUser();
        });
    },
    onChangeTrigger: function () {
      this.changeTriggerValue = this.subscription.trigger;
      this.$bvModal.show('changeTriggerModal');
    },
    openAuthForm: function (mode) {
      this.authBus.$emit('openAuthForm', mode);
    },
    onAuthComplete: function () {
      this.onStationAdded(this.triggers[1].value, true);
    },
    onStationAdded: function (trigger, isRetry) {

      if (!this.isAuthenticated) {
        if (isRetry)
          return;

        this.openAuthForm('signup');
      } else {

        this.addSubscription(this.stationId, trigger)
          .then(subscription => {
            this.loadUser();
          });
      }
    },
    onStationRemoved: function () {
      this.removeSubscription(this.subscription, this.item.station)
        .then(() => {
          this.loadUser();
        });
    },
    loadUser: function () {
      if (!this.isAuthenticated)
        return;

      this.readQuery('/graphql/public', {
        query: `
          query ($id: ID) {
            applicationUser (id: $id) {
              id
              userName
              subscriptions {
                id,
                trigger,
                station {
                  id
                }
              }
            }
          }`,
          variables: {
            'id': this.$root.$data.authenticatedUser.id
          }
        }, (data) => {
          this.user = data.applicationUser;
          this.subscription = data.applicationUser.subscriptions.find(x => x.station.id == this.stationId);
        });

    },
    load: function () {

      this.stationId = this.$route.params.id;
      this.allergenCollectionSetId = this.$route.params.allergenCollectionSetId;

      this.loadUser();

      if (!this.allergenCollectionSetId) {
        this.readQuery('/graphql/public', {
          query: `
            query {
              allergenCollectionSets (limit: 1, filter: "station.id=\\"` + this.stationId + `\\"", order: "date desc") {
                id,
                date
              }
            }`
          }, (data) => {
            if (!data.allergenCollectionSets || data.allergenCollectionSets.length == 0) {
              this.noData = true;
              return;
            };
            
            this.allergenCollectionSetId = data.allergenCollectionSets[0].id;
            this.loadAllergenCollectionSet();
          });
      } else {
        this.loadAllergenCollectionSet();
      }
    },
    loadAllergenCollectionSet: function () {
      this.readQuery('/graphql/public', {
        query: `
          query ($id: ID) {
            allergenCollectionSet (id: $id) {
              id,
              date,
              isCommentPublic,
              comment,
              weatherNotes,
              station {
                id,
                address1,
                address2,
                city,
                country,
                displayCity,
                faxNumber,
                headName,
                headEmail,
                isAddressPublic,
                name,
                name2,
                phoneNumber,
                postalCode,
                state,
                website,
                scaleSet {
                  id,
                  scales {
                    id,
                    category,
                    range1Begin,
                    range2Begin,
                    range3Begin,
                    range4Begin
                  }
                }
              }
              allergenCollections {
                id,
                value,
                allergen {
                  id,
                  name,
                  commonName,
                  family,
                  category
                }
              }
            }
          }`,
        variables: {
          'id': this.allergenCollectionSetId
        }
      }, (data) => {
        this.item = data.allergenCollectionSet;

        if (!this.item.station.isAddressPublic) {
          this.item.station.address1 = '';
          this.item.station.address2 = '';
          this.item.station.city = '';
          this.item.station.state = '';
          this.item.station.postalCode = '';
          this.item.station.country = '';
        }
      });        
    }    
  },
  mounted () {
    this.load();
    // Use this instead of the previous line to test the "Loading" bar
    //window.setTimeout(this.load, 3000);
  }
};
</script>